var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignoutIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.444 11.186c0-3.295-2.225-5.561-6.002-5.561h-5.23l-1.925.083L4.748 4.47 6.89 2.387a.854.854 0 0 0 .265-.63c0-.507-.357-.88-.896-.88a.995.995 0 0 0-.656.282L.838 5.857a.925.925 0 0 0 0 1.345L5.603 11.9a.995.995 0 0 0 .656.282c.54 0 .896-.373.896-.888a.882.882 0 0 0-.265-.63L4.748 8.58l-1.46-1.23 1.925.083H10.5c2.672 0 4.142 1.52 4.142 3.677 0 2.167-1.47 3.752-4.143 3.752H8.567a.892.892 0 0 0-.921.913c0 .498.382.905.921.905h1.993c3.71 0 5.885-2.183 5.885-5.495Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignoutIcon);
export default __webpack_public_path__ + "static/media/signoutIcon.5b2fb261529ae58803a294161494e290.svg";
export { ForwardRef as ReactComponent };